import { Card, CardBody, Col, Row, CardHeader, Form, Container, Label, Input } from "reactstrap";
import React, { useState, useEffect } from 'react';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import { api } from "../../config";
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import { fetchComAuth, fetchComAuthJson } from "../../common/api";

const ConfiguracaoGeral = () => {
    const [banner, setBanner] = useState(null);
    const [termosContrato, setTermosContrato] = useState('');
    const [bannerUrl, setBannerUrl] = useState(null);
    const { quill, quillRef } = useQuill();
    const [loading, setLoading] = useState(true);
    const [configId, setConfigId] = useState(null); // Novo estado para armazenar o ID se existir
    
    document.title = "Configuração Geral | EVOMAP - Tecnologia que conecta negócios";

    useEffect(() => {
        const carregarDados = async () => {
            try {
                const response = await fetchComAuth(`${api.API_URL}/configuracao-geral`, { method: 'GET'});
                const data = await response.json();
                
                if (data.status && data.data) {
                    const config = data.data;
                    
                    // Verifica se existe configuração e armazena o ID
                    if (config.id) {
                        setConfigId(config.id);
                    }
                    
                    if (config.bannerUrl) {
                        setBannerUrl(config.bannerUrl);
                    }
                    if (config.link_termos_uso_evomap) {
                        setTermosContrato(config.link_termos_uso_evomap);
                        if (quill) {
                            quill.clipboard.dangerouslyPasteHTML(config.link_termos_uso_evomap);
                        }
                    }
                }
            } catch (err) {
                console.error("Erro ao carregar a configuração geral", err);
                toast.error("Erro ao carregar os dados da configuração geral");
            } finally {
                setLoading(false);
            }
        };
        
        carregarDados();
    }, [quill]);

    const removeImage = () => {
        setBannerUrl(null);
        setBanner(null);
    };

  
    const salvarConfiguracao = async () => {
        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });
        
        let bannerBase64 = null;
        if (banner) {
            bannerBase64 = await toBase64(banner);
        }

        const payload = {
            link_termos_uso_evomap:  (quill ? quill.root.innerHTML : ''),
            ...(bannerBase64 && { banner: bannerBase64 }),
        };
    
        // Se já existir um ID, adicionamos ao payload para atualização
        if (configId) {
            payload.id = configId;
        }
    
        try {
            // Decide se usa POST (criação) ou PUT (atualização)
            const endpoint = `${api.API_URL}/configuracao-geral`;
            const method = configId ? 'PUT' : 'POST';
    
            const response = await fetchComAuthJson(endpoint, {
                method,
                body: JSON.stringify(payload)
            });
    
            const responseData = await response.json();
    
            if (response.ok) {
                // Se for criação, armazena o ID retornado
                if (!configId && responseData.data?.id) {
                    setConfigId(responseData.data.id);
                }
    
                // Atualiza a URL do banner se foi enviado um novo
                if (bannerBase64 && responseData.data?.link_banner_topo) {
                    setBannerUrl(`${api.API_URL}/uploads/configuracao_geral/${responseData.data.link_banner_topo}`);
                }
    
                toast.success(responseData.mensagem || "Configuração salva com sucesso!");
            } else {
                throw new Error(responseData.mensagem || "Erro ao salvar");
            }
        } catch (err) {
            console.error("Erro ao salvar configuração:", err);
            toast.error(err.message || "Erro ao salvar os dados informados da configuração!");
        }
    };

    if (loading) {
        return <div className="page-content">Carregando...</div>;
    }

    return (
        <React.Fragment>
            <ToastContainer closeButton={false} />
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Configuração Geral" pageTitle="Cadastro" />

                    <Row className="mt-2">
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <button
                                        type="submit"
                                        className="btn btn-success w-sm"
                                        onClick={salvarConfiguracao}
                                    >
                                        Salvar
                                    </button>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="mb-3">
                                                <Label className="form-label" htmlFor="banner-img">Banner tela de vendas:</Label>
                                                <Input 
                                                    className="form-control" 
                                                    id="banner-img" 
                                                    type="file" 
                                                    accept="image/png, image/gif, image/jpeg" 
                                                    onChange={(e) => {
                                                        setBanner(e.target.files[0]);
                                                        setBannerUrl(URL.createObjectURL(e.target.files[0]));
                                                    }}
                                                />
                                            </div>
                                            {bannerUrl && (
                                                <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                                                    <div style={{ position: "relative" }}>
                                                        <img
                                                            src={typeof bannerUrl === "string" ? bannerUrl : URL.createObjectURL(bannerUrl)}
                                                            alt="Banner"
                                                            style={{ 
                                                                width: "80px", 
                                                                height: "80px",
                                                                objectFit: "fit",
                                                                borderRadius: "4px"
                                                            }}
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={removeImage}
                                                            style={{
                                                                position: "absolute",
                                                                top: "-8px",
                                                                right: "-8px",
                                                                background: "#ff4444",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "50%",
                                                                cursor: "pointer"
                                                            }}
                                                            >
                                                            <i className="ri-close-fill align-bottom" />
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Label className="form-label" htmlFor="snow-editor">Informe os termos de aceite da reserva:</Label>
                                            <div className="snow-editor" style={{ height: 300 }}>
                                                <div ref={quillRef} />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ConfiguracaoGeral;